export default "__VITE_ASSET__8bc03212__"